import { SystemEntity } from "@erp/shared-types";
import { IDENTIFY_CUSTOMER_RESERVED_SOCKET_IDS } from "../../steps/ai/identify-customer.step";
import {
  generateIdentifyPartyOutputSockets,
  resolveIdentifyPartyOutputSockets,
  type ResolvedIdentifyPartyOutputSockets,
} from "./identifyPartyOutputSockets";
import type { DynamicSocketDefinition } from "./socketDefinition";

export type ResolvedIdentifyCustomerOutputSockets =
  ResolvedIdentifyPartyOutputSockets;

export function resolveIdentifyCustomerOutputSockets(
  config: Record<string, unknown>,
): ResolvedIdentifyCustomerOutputSockets {
  return resolveIdentifyPartyOutputSockets({
    stepType: "identify_customer",
    reserved: IDENTIFY_CUSTOMER_RESERVED_SOCKET_IDS,
    config,
    routesConfigKey: "customerRoutes",
    entityType: SystemEntity.AR_CUSTOMER,
    entityNoun: "Customer",
  });
}

export function generateIdentifyCustomerOutputSockets(
  config: Record<string, unknown>,
): DynamicSocketDefinition[] {
  return generateIdentifyPartyOutputSockets({
    stepType: "identify_customer",
    reserved: IDENTIFY_CUSTOMER_RESERVED_SOCKET_IDS,
    config,
    routesConfigKey: "customerRoutes",
    entityType: SystemEntity.AR_CUSTOMER,
    entityNoun: "Customer",
  });
}
